import { Modal, Table, Tag, Space, Spin } from "antd";
import dayjs from "dayjs";
import trans from "../../../utils";
import { useGetSingleDispatchPlanQuery } from "../../../Redux/service/Dispatcher/DispatcherPlan";

const PLAN_STATUS_COLORS = {
	Planned: "gold",
	Pending: "gold",
	Active: "blue",
	Completed: "green",
	Cancelled: "red",
};

function formatPreferredVisit(request) {
	if (!request.preferredVisitTime) return "-";
	const start = dayjs(request.preferredVisitTime);
	const startText = `${start.format("D MMM")} · ${start.format("hh:mm A")}`;
	if (!request.preferredVisitTimeEnd) return startText;
	return `${startText} – ${dayjs(request.preferredVisitTimeEnd).format("hh:mm A")}`;
}

export default function ViewDispatchPlanModal({
	planId,
	onClose,
	onRemoveRequest,
}) {
	const { data, isFetching } = useGetSingleDispatchPlanQuery(planId, {
		skip: !planId,
		refetchOnMountOrArgChange: true,
	});
	const plan = data?.data;
	const requests = plan?.serviceRequests || [];

	const columns = [
		{
			title: trans("Request ID"),
			dataIndex: "requestNumber",
			key: "requestNumber",
			width: 170,
		},
		{
			title: trans("Customer"),
			key: "customer",
			width: 160,
			render: (_, r) => r.poi?.name || "-",
		},
		{
			title: trans("Product"),
			dataIndex: "product",
			key: "product",
			width: 170,
			render: (v) => v || "-",
		},
		{
			title: trans("Assignee"),
			key: "assignee",
			width: 150,
			render: (_, r) => (
				<div className="text-capitalize">
					{plan?.assignedTo?.name || trans("Unassigned")}
				</div>
			),
		},
		{
			title: trans("Preferred Visit"),
			key: "preferredVisit",
			width: 190,
			render: (_, r) => formatPreferredVisit(r),
		},
	];

	return (
		<Modal
			open={!!planId}
			onCancel={onClose}
			maskClosable={false}
			width={900}
			centered
			footer={null}
			title={
				plan ? (
					<div>
						<Space align="center">
							<span className="fw-600 fs-16">{plan.code}</span>
							<Tag
								color={PLAN_STATUS_COLORS[plan.status] || "default"}
								className="text-capitalize"
							>
								{trans(plan.status)}
							</Tag>
						</Space>
						<div className="brand-700" style={{ fontSize: 13, marginTop: 4 }}>
							{trans("Dispatch Plan")} —{" "}
							{plan.plannedDate
								? dayjs(plan.plannedDate).format("D MMM YYYY")
								: "-"}
						</div>
					</div>
				) : (
					trans("Dispatch Plan")
				)
			}
		>
			{isFetching || !plan ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ minHeight: 200 }}
				>
					<Spin />
				</div>
			) : (
				<Table
					rowKey="id"
					columns={columns}
					dataSource={requests}
					pagination={false}
					scroll={{ x: "max-content" }}
				/>
			)}
		</Modal>
	);
}
